import { render } from "./reasons-header.vue?vue&type=template&id=840fbbd4&scoped=true&ts=true"
import script from "./reasons-header.vue?vue&type=script&lang=ts"
export * from "./reasons-header.vue?vue&type=script&lang=ts"

import "./reasons-header.vue?vue&type=style&index=0&id=840fbbd4&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840fbbd4"]])

export default __exports__